import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ajEvents as ajEventsLayout } from 'constants/layout'
import { apiCodeLists, apiCommon, apiActivities } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'

@apiCodeLists([
  'ajEventCategories',
  'modeOfTransportTypeList',
  'awardLevelTypes',
  'titles'
])
@apiCommon({
  countries: true
})
@apiActivities({
  template: 'nested',
  activityCategories: false,
  ajTypes: true
})
class AjEvent extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    tabs: PropTypes.object,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    activities: PropTypes.object.isRequired,
    onActivityParentChange: PropTypes.func.isRequired,
    route: PropTypes.object
  }

  render() {
    const {
      tabs,
      children,
      route,
      codeLists,
      common,
      activities,
      onActivityParentChange
    } = this.props

    const extraProps = {
      codeLists,
      common,
      activities,
      onActivityParentChange
    }

    return (
        <div>
          {tabs &&
          React.cloneElement(tabs, {
            links: ajEventsLayout.tabsMyEvents
          })}
          {children
              ? React.cloneElement(children, extraProps)
              : renderRoutes(route.routes, extraProps)
          }
        </div>
    )
  }
}

export default AjEvent
